import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Documentation from "./pages/Documentation";
import ExtraFeaturesDoc from "./components/documentation/ExtraFeaturesDoc";
import TelegramBotDoc from "./components/documentation/TelegramBotDoc";
import ImportantNotes from "./components/documentation/ImportantNotes";

const router = createBrowserRouter(
    [
        {
            path: "/",
            element: <Layout />,
            children: [{ index: true, element: <Home /> }],
        },
        {
            path: "/documentation",
            element: <Layout />,
            children: [
                { index: true, element: <Documentation /> },
                { path: "extra-features", element: <ExtraFeaturesDoc /> },
                { path: "telegram-bot-doc", element: <TelegramBotDoc /> },
                { path: "important-notes", element: <ImportantNotes /> },
            ],
        },
    ]
);

export default function App() {
    return <RouterProvider router={router} />;
}